import React from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-16 px-4 text-center",
        className,
      )}
    >
      {icon ? (
        <div className="mb-4 text-[var(--color-text-muted)] text-5xl">
          {icon}
        </div>
      ) : null}
      <h3 className="text-lg font-semibold text-[var(--color-text-dark)] mb-2">
        {title}
      </h3>
      {description ? (
        <p className="text-[var(--color-text-light)] max-w-sm mb-6">
          {description}
        </p>
      ) : null}
      {action ? <div>{action}</div> : null}
    </div>
  );
}
